import type { FilterComponentProps } from '@/app/common/filters/core/filterComponentType.ts';
import type { FilterDataSwitch } from '@/app/common/filters/core/filtersTypes.ts';
import { Switch } from '@lmn/design-system';
import styled from 'styled-components';
import { formatLabelCounter } from '@/app/common/filters/types/shared/utils/labelCounter.tsx';
import { BASE_PATH } from '@/app/components/search/utils/path.ts';
import React from 'react';
import Tooltip from '@/app/components/hotel-detail/Tooltip.tsx';
import { Counter } from '@/app/common/filters/types/shared/styled/Counter.styled.ts';
import { useFiltersUiData } from '@/app/common/filters/surfaces/provider/filtersUiProvider.tsx';
import { Text } from '@/app/common/filters/types/shared/styled/Text.styled.ts';
import { replacePlaceholdersWithBoldNodes } from '@/app/components/search/utils/translationNodes.tsx';
import { Icon } from '@/app/common/icons/Icon';
import { IconOrLegacyAsset } from '@/app/common/icons/IconOrLegacyAsset';

const SwitchContainer = styled.div`
  //  Switchstyles__Wrapper
  label {
    justify-content: space-between;
    width: 100%;
    min-height: 48px;

    // Switchstyles__SwitchWrapper

    > div {
      flex-shrink: 0;
    }

    // Switchstyles__LabelText
    > span {
      width: 100%;
      display: inline-flex;
      justify-content: space-between;
      align-items: center;
      margin-right: 8px;
    }
  }
`;

export const FilterSwitch = ({ filter, isLoading, handleFilterChanged }: FilterComponentProps) => {
  const { useEvoFilters, totalResults } = useFiltersUiData();
  const disabled = filter?.disabled;
  const filterData = filter.data as FilterDataSwitch;
  const isDisabled = disabled || isLoading;
  const { icon, tooltip } = filterData;

  const handleFilterClicked = (selected: boolean) => {
    const updatedFilter = {
      ...filter,
      data: {
        ...filter.data,
        selected,
      },
    };
    handleFilterChanged([updatedFilter]);
  };

  const countOnCta = !!useEvoFilters && totalResults !== undefined;
  const labelCounter = countOnCta ? undefined : formatLabelCounter(filterData.counter);
  const iconElement = icon ? (
    <IconOrLegacyAsset icon={typeof icon === 'string' ? `${BASE_PATH}/img/icons/${icon}.svg` : icon} size={16} />
  ) : null;
  const circleIcon = <Icon category="Semantics" name="icon-circle-info" size={16} color="iconDisabled" alt="" />;
  const label = (
    <>
      <Text>
        {iconElement}
        <span>
          {filterData.labelEmphasis ? replacePlaceholdersWithBoldNodes(filterData.labelEmphasis) : filterData.label}
        </span>
        {tooltip && (
          <Tooltip label={<div>{tooltip}</div>} placement="top" maxWidth={200} className="tooltip">
            {circleIcon}
          </Tooltip>
        )}
      </Text>
      {labelCounter && <Counter isDisabled={isDisabled}>{labelCounter}</Counter>}
    </>
  );

  return (
    <SwitchContainer key={filter.name}>
      <Switch
        checked={filterData.selected}
        // @ts-ignore
        label={label}
        ltr={true}
        isLoading={false}
        disabled={isDisabled || isLoading}
        onChange={handleFilterClicked}
      />
    </SwitchContainer>
  );
};
